const n = "_accent_17lgh_1", _ = "_active_17lgh_1", t = "_danger_17lgh_1", c = "_warning_17lgh_1", o = "_container_17lgh_3", e = "_xs_17lgh_21", a = "_sm_17lgh_29", s = "_md_17lgh_36", g = "_lg_17lgh_43", r = "_primary_17lgh_51", l = "_secondary_17lgh_57", i = "_tertiary_17lgh_63", d = "_content_17lgh_70", h = "_hidden_17lgh_82", y = "_text_17lgh_87", m = "_loadingIcon_17lgh_99", x = {
  accent: n,
  active: _,
  danger: t,
  warning: c,
  container: o,
  xs: e,
  sm: a,
  md: s,
  lg: g,
  primary: r,
  secondary: l,
  tertiary: i,
  content: d,
  hidden: h,
  text: y,
  loadingIcon: m
};
export {
  n as accent,
  _ as active,
  o as container,
  d as content,
  t as danger,
  x as default,
  h as hidden,
  g as lg,
  m as loadingIcon,
  s as md,
  r as primary,
  l as secondary,
  a as sm,
  i as tertiary,
  y as text,
  c as warning,
  e as xs
};
//# sourceMappingURL=Button.module.css.js.map
